import Colors from "./utils/constants/AppColors";
import { Duration, FixedHeight, FixedWidth, Opaciy } from "./utils/constants/ConstantsMapping";
import { getAppHeight, getAppWidth, getDeviceHeight, getDeviceWidth } from "./utils/services/CommonUtils";

const applyColorOpacity = (color: string, alpha: number) => {
    const alpha256 = (alpha * 255).toFixed()
    const alphaBase16 = Number(alpha256).toString(16)
    const paddedAlpha = alphaBase16.length === 1 ?
        alphaBase16.padStart(2, '0') : alphaBase16
    return color.concat('', paddedAlpha)
}

const AppTheme = {
    ...FixedHeight,
    ...FixedWidth,
    ...Duration,
    ...Opaciy,

    color: {
        ...Colors,
        fillerInfo: '#4c4c4c',
        lightGreyColor: '#bdbdbd',
        darkGrey: '#333333',
    },
}

export default AppTheme;